/**
 * ISMOOLI Predictive Search Enhancer
 * Extends Dawn predictive search with idle state, recently viewed, and animations.
 */
class GlycPredictiveSearchEnhancer {
  constructor() {
    this.instances = document.querySelectorAll('predictive-search');
    if (!this.instances.length) return;

    this.instances.forEach((instance) => this.enhance(instance));
  }

  enhance(instance) {
    const outerPanel = instance.querySelector('.predictive-search');
    const idlePanel = instance.querySelector('[data-glyc-predictive-idle]');
    const resultsPanel = instance.querySelector('[data-predictive-search]');
    const input = instance.querySelector('input[type="search"]');

    if (!outerPanel || !resultsPanel || !input) return;

    if (idlePanel) {
      GlycRecentlyViewed.bindPredictive(idlePanel);
    }

    input.addEventListener('focus', () => {
      if (!input.value.trim()) {
        this.showIdle(instance, idlePanel, resultsPanel, outerPanel);
      }
    });

    input.addEventListener('input', () => {
      if (!input.value.trim()) {
        this.showIdle(instance, idlePanel, resultsPanel, outerPanel);
      } else if (idlePanel) {
        idlePanel.hidden = true;
        resultsPanel.hidden = false;
      }
    });

    const observer = new MutationObserver(() => {
      if (instance.hasAttribute('results')) {
        if (idlePanel) idlePanel.hidden = true;
        resultsPanel.hidden = false;
        outerPanel.classList.remove('glyc-predictive-search--idle');
      }

      if (!instance.hasAttribute('open') && !input.value.trim() && idlePanel) {
        idlePanel.hidden = true;
        resultsPanel.hidden = false;
        outerPanel.classList.remove('glyc-predictive-search--idle');
      }
    });

    observer.observe(instance, { attributes: true, attributeFilter: ['open', 'loading', 'results'] });
  }

  showIdle(instance, idlePanel, resultsPanel, outerPanel) {
    if (!idlePanel) return;

    const input = instance.querySelector('input[type="search"]');
    if (!input) return;

    idlePanel.hidden = false;
    resultsPanel.hidden = true;
    outerPanel.classList.add('glyc-predictive-search--idle');

    if (typeof instance.getResultsMaxHeight === 'function') {
      outerPanel.style.maxHeight = `${instance.getResultsMaxHeight()}px`;
    }

    instance.setAttribute('open', true);
    input.setAttribute('aria-expanded', 'true');
  }
}

document.addEventListener('DOMContentLoaded', () => {
  new GlycPredictiveSearchEnhancer();
});
